import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/z/z/monorepo/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "assets/app.css",
    "revision": "ffd6a26c81de580f293c5f68175209b2"
  },
  {
    "url": "assets/fonts/KFOlCnqEu92Fr1MmEU9fBBc9.ttf",
    "revision": "8c608256fb0273e3a36e6b603f71f213"
  },
  {
    "url": "assets/fonts/KFOlCnqEu92Fr1MmSU5fBBc9.ttf",
    "revision": "806854d4422d0bd79e0f8c87c329a568"
  },
  {
    "url": "assets/fonts/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
    "revision": "96559ffb5be917f1ce9f748bf4f34732"
  },
  {
    "url": "assets/fonts/KFOmCnqEu92Fr1Mu4mxP.ttf",
    "revision": "329ae1c377b1fb667f5be6abd50327fc"
  },
  {
    "url": "assets/roboto.css",
    "revision": "bc73ad379628323dd8b59587bc5494aa"
  },
  {
    "url": "assets/synthwave.webp",
    "revision": "17e5d7f3a6a57b5c42f1e60a6bc3a658"
  },
  {
    "url": "assets/triangle-geometry.png",
    "revision": "9004e8a7889a9f9cfd1721e1430fcf8a"
  },
  {
    "url": "assets/zed-icon-big.png",
    "revision": "d71147f38c8eba4b5184eeb97a7a58d4"
  },
  {
    "url": "babel.mjs",
    "revision": "28f1dfbfc07e6095dde3876b81bdfacc"
  },
  {
    "url": "base/browser/ui/codicons/codicon/codicon.ttf",
    "revision": "205bdf70392b7b167acf6d7b4a3f86cf"
  },
  {
    "url": "public/editor.main-ZXURZYFH.css",
    "revision": "cf447cd2af614b4335ff06217df1bf55"
  },
  {
    "url": "public/starter.mjs",
    "revision": "a14c44cd79b5620625fb95733ae2a013"
  },
  {
    "url": "public/workers/js/appStarter.js",
    "revision": "202d31cc5a0536f3a72dca5d325eefe0"
  },
  {
    "url": "public/workers/js/workers/prettier.worker.js",
    "revision": "9949e331167acb9dc9baf9d54980afca"
  },
  {
    "url": "public/workers/monaco-editor/esm/vs/editor/editor.worker.js",
    "revision": "776b0144d52e57c983b657af175ce298"
  },
  {
    "url": "examples/starter_framer.js",
    "revision": "bd7afef2da12f2e71a35302f6faa1115"
  },
  {
    "url": "formatter.mjs",
    "revision": "0bf7a65bd0b9a464d4ffaf9c9215c6ae"
  },
  {
    "url": "getWorker.mjs",
    "revision": "6f5c6441134e5cf5809b883ac329e4c1"
  },
  {
    "url": "hello-world.js",
    "revision": "d59d4e06002a5b8549c042ca4ce104da"
  },
  {
    "url": "hydrated.html",
    "revision": "9d0636b393c66802bd0877ffa357fdf3"
  },
  {
    "url": "hydrateRoot.html",
    "revision": "babff72d0edfed8758754b1e36b8e0cb"
  },
  {
    "url": "importmap.json",
    "revision": "8cbabe0ce234c25917eb6b640230d074"
  },
  {
    "url": "importScript.mjs",
    "revision": "0688f6760164c8d5f9a1f48a33d1207e"
  },
  {
    "url": "index.html",
    "revision": "dda8edb2f94dc865c33fb086b3900564"
  },
  {
    "url": "quickStart.mjs",
    "revision": "0178632c699bf68460543f8495f9d8bc"
  },
  {
    "url": "starter.mjs",
    "revision": "c2b57af7918d7fd5a01f5faf4addb723"
  },
  {
    "url": "test.mjs",
    "revision": "2651f864dacad7cdc0b4e20133be55a1"
  },
  {
    "url": "uidV4.mjs",
    "revision": "c6fdf2a908f7ea613ea537a2666f6fb5"
  },
  {
    "url": "vendor/mui.mjs",
    "revision": "2bbe1fa805bfaddd77eac902e393c313"
  },
  {
    "url": "vendor/renderToString.mjs",
    "revision": "37469f1325e45635d0e8d767ba8e4fb8"
  },
  {
    "url": "workboxLoader.mjs",
    "revision": "891b54222faeb2953dde97191c7b07c5"
  },
  {
    "url": "workers/babel.worker.js",
    "revision": "790d468074d3632321fe6cc8d6abca7d"
  },
  {
    "url": "workers/custom-worker.js",
    "revision": "77b74e9ad2affbe5f91ae61872e272b9"
  },
  {
    "url": "workers/esbuild.worker.js",
    "revision": "c6279715ced465ed2728e78659b2270e"
  },
  {
    "url": "workers/prettier.worker.js",
    "revision": "e611d96e85049c67801e1251d905253b"
  },
  {
    "url": "ws.mjs",
    "revision": "4c8121bb0edb92eb1a88105f72b5aa84"
  }
], {});








